import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useEffect, useState } from 'react';
import i18n from '../translation/i18n';
import Select from 'react-select';
import styled from 'styled-components';

dayjs.extend(relativeTime);

const ReactSelectStyle = styled.div`
  .select__single-value {
    cursor: pointer;
    color: var(--text-primary);
  }
  .basic-single > :nth-child(3) {
    border: 0;
    background-color: transparent;

    span {
      background-color: var(--outline);
    }

    > :last-child > :last-child {
      > svg {
        height: 1rem;
        width: 1rem;
      }
    }
  }

  .select__menu {
    position: absolute;
    z-index: 9999;
    .select__menu-list {
      background-color: var(--tonal);
      .select__option {
        color: var(--text-primary);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.35rem 0.5rem;
        > div {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
        }
        &:hover,
        &.select__option--is-focused {
          background-color: var(--tonal-deep);
        }
        &.select__option--is-selected {
          background-color: var(--selected-primary);
        }
      }
    }
  }

  img {
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    border: 0.5px solid var(--tonal);
  }
`;

const options: any[] = [
  {
    value: 'ko-KR',
    label: (
      <div>
        <img src='/img/country/K.svg' />
      </div>
    ),
  },
  {
    value: 'en-US',
    label: (
      <div>
        <img src='/img/country/E.svg' />
      </div>
    ),
  },
  // {
  //   value: 'vi-VN',
  //   label: (
  //     <div>
  //       <img src='/img/country/V.svg' />
  //     </div>
  //   ),
  // },
];

const Language: React.FC<{ dropdownPosition?: 'top' | 'bottom' }> = ({ dropdownPosition = 'bottom' }): any => {
  const localeLang = i18n.language.substring(0, 2);
  const [localeState, setlocaleState] = useState(options.find((v: any) => v.value === i18n.language));

  useEffect(() => {
    dayjs.locale(localeLang);
  }, [i18n.language]);

  const customStyles: any = {
    // container: (provided: any, state: any, mode: any) => ({}),
    singleValue: (provided: any) => ({
      ...provided,
      marginLeft: 0,
      marginRight: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
    indicatorsContainer: (provided: any, state: any) => ({
      ...provided,
      padding: '0',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      padding: '0',
    }),
    indicatorSeparator: () => null,
  };

  const handleChangeSelect = (e: any) => {
    const locale = e.value;
    i18n.changeLanguage(locale);
    setlocaleState(options.find((v: any) => v.value === locale));
    window.localStorage.setItem('language', locale);
  };

  return (
    <ReactSelectStyle>
      <Select
        className='basic-single'
        classNamePrefix='select'
        value={localeState}
        options={options}
        styles={customStyles}
        onChange={handleChangeSelect}
        isSearchable={false}
        menuPlacement={dropdownPosition}
        menuPosition='fixed'
      />
    </ReactSelectStyle>
  );
};
export default Language;
